module.exports = __webpack_public_path__ + "static/img/banner.98fce9ec.jpg";